<a mat-flat-button class="certification-icon-container" (click)="requestCertification()" [matTooltip]="
    certified
      ? 'Certificado Hub Medical'
      : 'Solicitar Certificação Hub Medical'
  ">
  Solicitar Certificação
</a>